var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAutorizationRequest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 318,
    height: 300,
    viewBox: "0 0 318 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3256_12762)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.697 2.409C92.6024 5.97948 68.4823 13.8214 48.2149 27.684C18.5593 47.9931 2.10772 78.3127 0.395403 111.299C-0.741224 133.075 5.11905 154.308 12.2045 174.984C21.3049 201.582 27.18 231.882 46.1557 254.615C75.7449 289.993 132.945 304.917 180.78 298.581C211.683 294.493 244.335 278.927 253.849 250.757C257.369 240.334 259.089 229.137 265.104 219.5C272.308 207.957 285.386 201.216 295.313 191.814C307.573 180.205 312.518 165.74 315.573 150.436C322.651 114.954 312.193 75.9477 287.785 47.148C261.126 15.7016 217.853 4.20407 175.547 0.921851C156.571 -0.584954 136.857 -0.349106 117.697 2.409Z",
    fill: "#004087"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M117.697 2.409C92.6024 5.97948 68.4823 13.8214 48.2149 27.684C18.5593 47.9931 2.10772 78.3127 0.395403 111.299C-0.741224 133.075 5.11905 154.308 12.2045 174.984C21.3049 201.582 27.18 231.882 46.1557 254.615C75.7449 289.993 132.945 304.917 180.78 298.581C211.683 294.493 244.335 278.927 253.849 250.757C257.369 240.334 259.089 229.137 265.104 219.5C272.308 207.957 285.386 201.216 295.313 191.814C307.573 180.205 312.518 165.74 315.573 150.436C322.651 114.954 312.193 75.9477 287.785 47.148C261.126 15.7016 217.853 4.20407 175.547 0.921851C156.571 -0.584954 136.857 -0.349106 117.697 2.409Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.117 241.496C216.464 241.496 263.764 194.196 263.764 135.848C263.764 77.5011 216.464 30.2012 158.117 30.2012C99.7692 30.2012 52.4694 77.5011 52.4694 135.848C52.4694 194.196 99.7692 241.496 158.117 241.496Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeDasharray: "3.01 3.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.784 97.9593C244.784 97.9593 208.968 93.2888 160.312 43.2159V42.5249L159.971 42.866L159.638 42.5249V43.2159C111.017 93.2888 75.1924 97.9593 75.1924 97.9593C62.4314 202.846 151.067 238.776 159.656 242.029V242.274L159.988 242.152L160.329 242.274V242.029C168.918 238.776 257.554 202.802 244.784 97.9593Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.155 101.379C238.155 101.379 205.155 97.0845 160.312 50.93V50.2915L159.997 50.6151L159.691 50.2915V50.93C114.84 97.1107 81.8484 101.379 81.8484 101.379C70.0758 198.096 151.819 231.254 159.691 234.236V234.464L159.997 234.35L160.312 234.464V234.236C168.227 231.254 249.953 198.096 238.155 101.379Z",
    fill: "#004087"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M222.009 109.863C222.009 109.863 195.77 106.478 160.233 69.8482V69.3496C160.154 69.4283 160.076 69.5158 159.988 69.5945L159.743 69.3496V69.8482C124.172 106.478 97.9766 109.863 97.9766 109.863C88.6355 186.568 153.464 212.869 159.743 215.23V215.414L159.988 215.318L160.233 215.414V215.23C166.522 212.869 231.341 186.568 222.009 109.863Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.1896 70.2243C107.092 70.2243 115.12 62.1968 115.12 52.2943C115.12 42.3918 107.092 34.3643 97.1896 34.3643C87.2871 34.3643 79.2595 42.3918 79.2595 52.2943C79.2595 62.1968 87.2871 70.2243 97.1896 70.2243Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8863 47.5975H94.3732V42.6296C94.3755 42.0318 94.614 41.4592 95.0366 41.0365C95.4593 40.6138 96.032 40.3754 96.6297 40.373C96.9261 40.373 97.2195 40.4314 97.4933 40.5448C97.7671 40.6582 98.0158 40.8244 98.2254 41.034C98.4349 41.2435 98.6011 41.4923 98.7145 41.7661C98.8279 42.0398 98.8863 42.3333 98.8863 42.6296V47.5975Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.9562 43.9768C95.8831 43.9762 95.8112 43.9582 95.7463 43.9244L91.9154 41.8865C91.8435 41.8515 91.783 41.7967 91.7412 41.7285C91.6994 41.6603 91.6779 41.5816 91.6793 41.5016V38.5716C91.6793 38.4556 91.7253 38.3444 91.8074 38.2624C91.8894 38.1804 92.0006 38.1343 92.1166 38.1343C92.2326 38.1343 92.3438 38.1804 92.4258 38.2624C92.5078 38.3444 92.5539 38.4556 92.5539 38.5716V41.2392L96.1574 43.1459C96.2734 43.1726 96.374 43.2443 96.4372 43.3451C96.5003 43.446 96.5208 43.5679 96.4941 43.6838C96.4675 43.7998 96.3958 43.9005 96.2949 43.9636C96.194 44.0268 96.0722 44.0473 95.9562 44.0206V43.9768Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.3383 43.9768C97.2223 44.0047 97.1 43.9853 96.9983 43.923C96.8966 43.8606 96.8238 43.7605 96.796 43.6445C96.7682 43.5285 96.7875 43.4062 96.8499 43.3045C96.9122 43.2028 97.0124 43.13 97.1283 43.1022L100.732 41.1955V38.5716C100.732 38.4556 100.778 38.3444 100.86 38.2624C100.942 38.1804 101.053 38.1343 101.169 38.1343C101.285 38.1343 101.396 38.1804 101.478 38.2624C101.56 38.3444 101.606 38.4556 101.606 38.5716V41.5016C101.608 41.5805 101.587 41.6581 101.547 41.726C101.507 41.7939 101.449 41.8495 101.379 41.8865L97.5394 43.9244C97.4781 43.9592 97.4088 43.9773 97.3383 43.9768Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8571 63.3937C102.093 63.3937 106.338 59.1489 106.338 53.9127C106.338 48.6764 102.093 44.4316 96.8571 44.4316C91.6209 44.4316 87.3761 48.6764 87.3761 53.9127C87.3761 59.1489 91.6209 63.3937 96.8571 63.3937Z",
    fill: "#004087",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.3878 51.6472C80.2696 51.6469 80.1564 51.5997 80.0729 51.516C79.9923 51.4328 79.9471 51.3214 79.9471 51.2055C79.9471 51.0896 79.9923 50.9782 80.0729 50.895L83.4578 47.5102C83.5149 47.4555 83.5854 47.417 83.6622 47.3985C83.7391 47.3801 83.8195 47.3824 83.8951 47.4052L88.5132 48.7609C88.5706 48.777 88.6243 48.8042 88.6712 48.8411C88.7181 48.8779 88.7573 48.9236 88.7865 48.9756C88.8158 49.0276 88.8345 49.0848 88.8416 49.144C88.8487 49.2032 88.8441 49.2632 88.8281 49.3207C88.812 49.3781 88.7847 49.4318 88.7479 49.4787C88.7111 49.5256 88.6653 49.5648 88.6134 49.594C88.5614 49.6233 88.5042 49.642 88.445 49.6491C88.3857 49.6562 88.3257 49.6516 88.2683 49.6355L83.8951 48.3498L80.7202 51.516C80.6771 51.56 80.6253 51.5945 80.568 51.6171C80.5107 51.6397 80.4493 51.65 80.3878 51.6472Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.0612 57.2885C80.9784 57.2878 80.8975 57.2636 80.8279 57.2188C80.7583 57.1739 80.7029 57.1102 80.6681 57.0351C80.6333 56.96 80.6205 56.8765 80.6313 56.7944C80.642 56.7123 80.6759 56.6349 80.7289 56.5713L83.2128 53.6325C83.2531 53.5833 83.3038 53.5436 83.3613 53.5164C83.4188 53.4891 83.4816 53.475 83.5452 53.4751H87.3761C87.4921 53.4751 87.6033 53.5212 87.6853 53.6032C87.7673 53.6852 87.8134 53.7964 87.8134 53.9124C87.8134 54.0284 87.7673 54.1396 87.6853 54.2216C87.6033 54.3037 87.4921 54.3497 87.3761 54.3497H83.7464L81.3936 57.1311C81.3534 57.1803 81.3027 57.22 81.2452 57.2473C81.1877 57.2745 81.1248 57.2886 81.0612 57.2885Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7726 63.6034H83.7114C83.5976 63.586 83.495 63.5254 83.4249 63.4341C83.3548 63.3428 83.3227 63.228 83.3353 63.1136L83.7901 59.5014C83.797 59.4411 83.816 59.3829 83.8461 59.3303C83.8761 59.2777 83.9166 59.2317 83.9651 59.1952L87.5161 56.7025C87.6118 56.637 87.7292 56.6113 87.8435 56.6309C87.9578 56.6505 88.0599 56.7138 88.1283 56.8075C88.1619 56.8545 88.1858 56.9077 88.1987 56.964C88.2116 57.0203 88.2132 57.0786 88.2034 57.1355C88.1937 57.1924 88.1727 57.2468 88.1418 57.2956C88.1109 57.3444 88.0707 57.3866 88.0234 57.4197L84.6298 59.8075L84.2012 63.2186C84.1885 63.3237 84.1381 63.4207 84.0592 63.4915C83.9804 63.5623 83.8786 63.6021 83.7726 63.6034Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.335 51.6474C113.217 51.6471 113.104 51.5999 113.02 51.5162L109.819 48.3151L105.446 49.6445C105.389 49.6612 105.328 49.6663 105.269 49.6597C105.21 49.6532 105.152 49.6349 105.1 49.6061C105.047 49.5773 105.001 49.5384 104.964 49.4917C104.926 49.445 104.899 49.3914 104.882 49.334C104.865 49.2766 104.86 49.2164 104.867 49.157C104.873 49.0976 104.891 49.04 104.92 48.9876C104.949 48.9352 104.988 48.889 105.035 48.8517C105.081 48.8143 105.135 48.7865 105.192 48.7699L109.828 47.3705C109.903 47.3457 109.984 47.3424 110.062 47.361C110.139 47.3795 110.209 47.4191 110.265 47.4754L113.65 50.8602C113.731 50.9435 113.776 51.0548 113.776 51.1707C113.776 51.2866 113.731 51.398 113.65 51.4812C113.612 51.5295 113.565 51.5692 113.51 51.5978C113.456 51.6264 113.396 51.6433 113.335 51.6474Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.653 57.2885C112.589 57.2886 112.527 57.2745 112.469 57.2473C112.412 57.22 112.361 57.1803 112.321 57.1311L109.968 54.3497H106.338C106.222 54.3497 106.111 54.3037 106.029 54.2216C105.947 54.1396 105.901 54.0284 105.901 53.9124C105.901 53.7964 105.947 53.6852 106.029 53.6032C106.111 53.5212 106.222 53.4751 106.338 53.4751H110.169C110.234 53.4761 110.298 53.4906 110.356 53.5177C110.415 53.5448 110.467 53.5839 110.51 53.6325L112.985 56.5713C113.023 56.6146 113.051 56.665 113.069 56.7195C113.087 56.774 113.093 56.8314 113.089 56.8885C113.084 56.9456 113.067 57.0011 113.041 57.0518C113.014 57.1025 112.977 57.1473 112.933 57.1836C112.856 57.2524 112.756 57.2899 112.653 57.2885Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.942 63.6035C109.836 63.6021 109.734 63.5624 109.655 63.4916C109.576 63.4208 109.526 63.3238 109.513 63.2187L109.085 59.7988L105.717 57.3761C105.665 57.3452 105.62 57.3038 105.585 57.2545C105.549 57.2052 105.525 57.1492 105.512 57.0898C105.5 57.0305 105.5 56.9692 105.512 56.9099C105.525 56.8506 105.549 56.7945 105.585 56.7452C105.62 56.6959 105.665 56.6545 105.717 56.6236C105.769 56.5927 105.827 56.573 105.887 56.5657C105.948 56.5584 106.009 56.5637 106.067 56.5812C106.125 56.5988 106.179 56.6282 106.225 56.6676L109.723 59.2041C109.772 59.2387 109.814 59.2829 109.845 59.334C109.877 59.3851 109.898 59.4421 109.907 59.5015L110.353 63.1137C110.368 63.2285 110.337 63.3445 110.266 63.4363C110.196 63.5281 110.091 63.5883 109.977 63.6035H109.942Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.2944 63.3934H96.4198V50.4488L99.3061 48.3672L99.8221 49.0756L97.2944 50.9036V63.3934Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.2769 57.4635L96.8921 56.685L101.606 54.3235V50.0815H102.481V54.8658L97.2769 57.4635Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.6298 54.2884L92.8076 51.9006V48.0522H93.6823V51.4196L97.0933 53.545L96.6298 54.2884Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.621 60.8311L91.4519 57.5425V54.1401H92.3265V57.0614L97.0933 60.0877L96.621 60.8311Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.1836 48.9796C93.6763 48.9796 94.0758 48.5802 94.0758 48.0874C94.0758 47.5947 93.6763 47.1953 93.1836 47.1953C92.6909 47.1953 92.2915 47.5947 92.2915 48.0874C92.2915 48.5802 92.6909 48.9796 93.1836 48.9796Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.7347 49.5567C100.227 49.5567 100.627 49.1573 100.627 48.6646C100.627 48.1719 100.227 47.7725 99.7347 47.7725C99.242 47.7725 98.8425 48.1719 98.8425 48.6646C98.8425 49.1573 99.242 49.5567 99.7347 49.5567Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.857 49.9943C102.857 50.1673 102.806 50.3363 102.71 50.4802C102.614 50.624 102.477 50.7361 102.317 50.8023C102.157 50.8685 101.982 50.8858 101.812 50.8521C101.642 50.8183 101.486 50.735 101.364 50.6127C101.242 50.4904 101.158 50.3346 101.125 50.1649C101.091 49.9952 101.108 49.8194 101.174 49.6595C101.241 49.4997 101.353 49.3631 101.497 49.267C101.64 49.1709 101.81 49.1196 101.983 49.1196C102.215 49.1196 102.437 49.2118 102.601 49.3758C102.765 49.5398 102.857 49.7623 102.857 49.9943Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.79 54.0177C92.79 54.1907 92.7387 54.3598 92.6426 54.5036C92.5465 54.6475 92.4099 54.7596 92.2501 54.8258C92.0903 54.892 91.9144 54.9093 91.7448 54.8755C91.5751 54.8418 91.4193 54.7585 91.297 54.6362C91.1746 54.5138 91.0913 54.358 91.0576 54.1883C91.0238 54.0187 91.0411 53.8428 91.1073 53.683C91.1735 53.5232 91.2857 53.3866 91.4295 53.2905C91.5733 53.1944 91.7424 53.1431 91.9154 53.1431C92.1474 53.1431 92.3698 53.2352 92.5339 53.3992C92.6979 53.5633 92.79 53.7857 92.79 54.0177Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.587 41.4474C118.926 37.9929 117.211 34.1069 113.757 32.7676C110.302 31.4284 106.416 33.1432 105.077 36.5977C103.738 40.0521 105.452 43.9382 108.907 45.2774C112.361 46.6166 116.247 44.9018 117.587 41.4474Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.373 43.111L116.292 34.9419",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.429 70.2243C232.331 70.2243 240.359 62.1968 240.359 52.2943C240.359 42.3918 232.331 34.3643 222.429 34.3643C212.526 34.3643 204.499 42.3918 204.499 52.2943C204.499 62.1968 212.526 70.2243 222.429 70.2243Z",
    fill: "#004087"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.417 67.2246L232.286 67.3033",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.72 67.3472C215.629 69.2529 219.03 70.2682 222.507 70.2684",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.662 44.6065C237.625 42.4454 236.168 40.5127 234.376 38.9214",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.286 67.3472C229.38 69.2527 225.982 70.268 222.507 70.2684",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.417 67.2246C234.597 65.7699 236.433 63.8564 237.796 61.6182",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.796 61.6182C238.876 59.8696 239.643 57.9457 240.061 55.9331",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.72 67.3468C210.484 65.8841 208.602 63.9421 207.21 61.6616",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.63 38.8774C213.902 35.9679 218.129 34.3618 222.507 34.3643",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.376 38.8774C231.106 35.9699 226.883 34.364 222.507 34.3643",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.061 55.9766C240.311 54.7799 240.437 53.5607 240.437 52.3381C240.433 51.654 240.39 50.9706 240.306 50.2915",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.662 44.6064C239.527 46.3953 240.082 48.3174 240.306 50.2916",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.918 55.9766C204.672 54.7796 204.548 53.5604 204.551 52.3381C204.552 51.6541 204.593 50.9708 204.674 50.2915",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.63 38.8774C208.837 40.4687 207.38 42.4015 206.344 44.5626",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.344 44.6064C205.483 46.3968 204.928 48.3182 204.7 50.2916",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.918 55.9766C205.34 57.9879 206.107 59.9113 207.184 61.6617",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.507 38.8774H234.376",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.63 38.8774H222.507",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.662 44.5625H206.344",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.306 50.248H204.7",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.417 55.9331H240.061",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.956 55.9331H204.945",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.417 55.9331H212.956",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.796 61.6182H207.21",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.286 67.3032H232.417",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.507 67.3032H232.286",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.956 67.3032H212.72",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.507 67.3032H212.956",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.507 38.8774V34.3643",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.417 39.3149V44.5628",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.956 39.3149V44.5628",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.507 44.7812V50.1865",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.417 55.933V50.7114",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.956 50.7114V55.933",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.507 56.1514V61.5566",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.507 67.3032V70.2245",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.417 67.2244V62.0815",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.417 67.2246V67.3033",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.956 62.0815V67.3031",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.429 70.2243C232.331 70.2243 240.359 62.1968 240.359 52.2943C240.359 42.3918 232.331 34.3643 222.429 34.3643C212.526 34.3643 204.499 42.3918 204.499 52.2943C204.499 62.1968 212.526 70.2243 222.429 70.2243Z",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.041 50.7288C244.216 53.4927 239.335 54.6734 235.531 52.8104C232.531 51.341 230.117 48.8658 230.641 45.2273C231.166 41.5889 234.42 39.5685 235.784 36.2798C237.245 32.7813 237.341 27.2886 237.341 27.2886C237.341 27.2886 239.869 30.1574 240.157 31.9067C240.337 32.9676 240.437 34.0406 240.455 35.1166L242.353 30.0524C242.773 31.8017 243.105 33.6384 243.647 35.3615C244.609 38.379 247.329 39.9008 248.694 42.5422C250.058 45.1836 249.14 48.6297 247.041 50.7288Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.904 52.4255C239.904 52.4255 237.044 50.3089 237.595 47.3613C238.146 44.4138 239.991 43.8628 239.991 43.8628C240.608 44.4173 241.094 45.1022 241.413 45.8677C241.732 46.6331 241.877 47.46 241.837 48.2884C241.765 49.8688 241.07 51.3563 239.904 52.4255Z",
    fill: "#004087",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.207 169.496C65.1095 169.496 73.137 161.468 73.137 151.566C73.137 141.663 65.1095 133.636 55.207 133.636C45.3045 133.636 37.277 141.663 37.277 151.566C37.277 161.468 45.3045 169.496 55.207 169.496Z",
    fill: "#004087"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2071 169.496C62.8537 169.496 69.0525 161.468 69.0525 151.566C69.0525 141.663 62.8537 133.636 55.2071 133.636C47.5604 133.636 41.3616 141.663 41.3616 151.566C41.3616 161.468 47.5604 169.496 55.2071 169.496Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.207 169.496C58.8298 169.496 61.7668 161.468 61.7668 151.566C61.7668 141.663 58.8298 133.636 55.207 133.636C51.5841 133.636 48.6472 141.663 48.6472 151.566C48.6472 161.468 51.5841 169.496 55.207 169.496Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8658 136.259H64.2594",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2041 145.391H71.93",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.277 154.522H72.8484",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9592 163.662H69.1662",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.207 169.496C65.1095 169.496 73.137 161.468 73.137 151.566C73.137 141.663 65.1095 133.636 55.207 133.636C45.3045 133.636 37.277 141.663 37.277 151.566C37.277 161.468 45.3045 169.496 55.207 169.496Z",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.277 148.863C65.596 148.865 63.9844 149.534 62.7957 150.723C61.607 151.911 60.9382 153.523 60.9359 155.204V169.679H73.6181V155.248C73.6227 154.412 73.4622 153.583 73.1457 152.809C72.8292 152.035 72.363 151.331 71.7738 150.738C71.1846 150.145 70.4841 149.674 69.7124 149.352C68.9407 149.03 68.1131 148.864 67.277 148.863ZM62.6852 156.953V155.204C62.6852 153.986 63.169 152.818 64.0301 151.957C64.8912 151.096 66.0592 150.612 67.277 150.612C68.4949 150.612 69.6628 151.096 70.5239 151.957C71.3851 152.818 71.8689 153.986 71.8689 155.204V156.953H62.6852Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9826 161.808C68.9794 161.494 68.8921 161.187 68.7297 160.919C68.5674 160.651 68.336 160.432 68.0598 160.284C67.7836 160.136 67.4727 160.065 67.1596 160.078C66.8464 160.091 66.5426 160.188 66.2799 160.359C66.0171 160.53 65.8051 160.768 65.666 161.049C65.5268 161.33 65.4657 161.643 65.489 161.955C65.5122 162.268 65.619 162.568 65.7981 162.825C65.9773 163.083 66.2222 163.287 66.5074 163.417L66.0438 167.257H68.3966L67.933 163.417C68.2459 163.28 68.512 163.055 68.6985 162.769C68.885 162.483 68.9838 162.149 68.9826 161.808Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.691 169.496C274.593 169.496 282.621 161.468 282.621 151.566C282.621 141.663 274.593 133.636 264.691 133.636C254.789 133.636 246.761 141.663 246.761 151.566C246.761 161.468 254.789 169.496 264.691 169.496Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.414 147.341H251.029V138.691H269.536L272.414 147.341Z",
    fill: "#004087",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.423 143.738H251.029V162.481H278.423V143.738Z",
    fill: "#004087",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.379 149.3C273.698 149.303 272.086 149.971 270.898 151.16C269.709 152.349 269.04 153.96 269.038 155.641V170.073H281.72V155.685C281.725 154.849 281.564 154.02 281.248 153.246C280.931 152.473 280.465 151.769 279.876 151.176C279.287 150.582 278.586 150.111 277.814 149.789C277.043 149.468 276.215 149.301 275.379 149.3ZM270.787 157.434V155.685C270.787 154.467 271.271 153.299 272.132 152.438C272.993 151.577 274.161 151.093 275.379 151.093C276.597 151.093 277.765 151.577 278.626 152.438C279.487 153.299 279.971 154.467 279.971 155.685V157.434H270.787Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.085 162.219C277.082 161.905 276.995 161.597 276.833 161.329C276.671 161.06 276.439 160.84 276.162 160.691C275.886 160.543 275.574 160.472 275.26 160.485C274.947 160.498 274.642 160.596 274.379 160.768C274.117 160.939 273.905 161.178 273.766 161.46C273.627 161.742 273.567 162.056 273.591 162.369C273.616 162.682 273.724 162.982 273.905 163.239C274.085 163.496 274.332 163.699 274.618 163.828L274.155 167.668H276.499L276.035 163.828C276.348 163.692 276.614 163.466 276.801 163.18C276.987 162.894 277.086 162.56 277.085 162.219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.152 148.067C152.152 148.067 121.828 164.099 121.242 165.848C120.656 167.598 125.615 200.545 127.364 212.204C128.561 221.014 129.244 229.886 129.411 238.776V243.735H209.878C209.878 243.735 215.703 158.309 213.665 157.434C211.627 156.56 176.055 144.901 176.055 144.901L152.152 148.067Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.813 184.286C183.813 184.286 180.586 183.875 176.204 179.362V179.3V179.362C171.831 183.875 168.595 184.286 168.595 184.286C167.44 193.741 175.426 196.985 176.204 197.274C176.974 196.985 184.968 193.741 183.813 184.286Z",
    fill: "#004087"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.187 198.166C176.132 198.175 176.075 198.175 176.02 198.166C175.916 198.152 175.816 198.12 175.723 198.07C173.004 197.016 170.725 195.069 169.259 192.548C167.794 190.027 167.229 187.082 167.659 184.198C167.683 184.005 167.771 183.825 167.908 183.687C168.046 183.549 168.226 183.461 168.42 183.437C168.42 183.437 171.402 182.965 175.417 178.854C175.486 178.741 175.579 178.644 175.689 178.57C175.799 178.496 175.924 178.447 176.055 178.426C176.209 178.399 176.367 178.417 176.51 178.478C176.697 178.554 176.854 178.689 176.956 178.863C180.953 182.921 183.892 183.394 183.953 183.394C184.144 183.421 184.32 183.51 184.454 183.648C184.588 183.786 184.674 183.964 184.697 184.155C185.126 187.034 184.564 189.974 183.104 192.493C181.644 195.011 179.371 196.959 176.659 198.017C176.518 198.109 176.355 198.16 176.187 198.166ZM169.338 184.994C169.097 187.373 169.631 189.766 170.863 191.815C172.094 193.865 173.956 195.461 176.169 196.364C178.383 195.46 180.244 193.864 181.477 191.815C182.71 189.766 183.247 187.373 183.009 184.994C181.837 184.653 179.3 183.604 176.169 180.569C173.038 183.604 170.51 184.653 169.338 184.994Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.19 165.481C154.19 165.481 153.612 193.837 154.19 208.417C154.767 222.997 156.525 243.691 156.525 243.691",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.813 176.921C157.456 176.921 157.977 176.4 157.977 175.758C157.977 175.116 157.456 174.595 156.813 174.595C156.171 174.595 155.65 175.116 155.65 175.758C155.65 176.4 156.171 176.921 156.813 176.921Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.813 204.035C157.456 204.035 157.977 203.514 157.977 202.872C157.977 202.229 157.456 201.708 156.813 201.708C156.171 201.708 155.65 202.229 155.65 202.872C155.65 203.514 156.171 204.035 156.813 204.035Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.437 224.16C159.437 224.392 159.368 224.619 159.239 224.812C159.11 225.005 158.927 225.155 158.712 225.244C158.497 225.332 158.261 225.355 158.033 225.309C157.806 225.263 157.597 225.151 157.434 224.986C157.27 224.821 157.159 224.611 157.115 224.384C157.071 224.156 157.095 223.92 157.185 223.706C157.275 223.492 157.427 223.309 157.621 223.182C157.815 223.054 158.042 222.987 158.274 222.988C158.583 222.991 158.879 223.115 159.097 223.335C159.315 223.554 159.437 223.851 159.437 224.16Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.636 232.032L181.592 236.694C181.592 236.694 170.222 229.408 166.434 229.111C162.647 228.814 157.977 229.408 155.353 231.735C152.729 234.061 151.277 235.819 148.356 235.819C145.434 235.819 141.945 236.108 143.694 238.443C145.443 240.779 151.566 240.779 153.901 239.904C156.236 239.029 159.726 238.155 159.726 238.155C160.951 239.833 162.693 241.062 164.685 241.653C166.781 242.195 168.932 242.488 171.096 242.528C171.096 242.528 176.641 246.026 180.14 245.729C182.242 245.556 184.307 245.067 186.262 244.277L197.047 241.067C197.047 241.067 194.134 234.07 190.636 232.032Z",
    fill: "#ABABAB",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.811 226.784C163.811 226.784 160.312 224.737 158.563 226.784C156.813 228.831 156.227 239.318 157.102 240.481C157.977 241.644 158.563 239.029 159.726 238.154C160.889 237.28 163.811 226.784 163.811 226.784Z",
    fill: "#ABABAB",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.933 227.947C169.933 227.947 165.56 225.324 163.811 226.784C162.061 228.245 158.851 239.904 159.726 241.067C160.601 242.23 163.225 241.067 163.522 239.606C163.819 238.146 168.77 230.571 168.77 230.571L169.933 227.947Z",
    fill: "#ABABAB",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.93 232.653C176.93 232.653 171.394 227.405 169.933 227.991C168.472 228.577 160.312 240.822 162.35 242.274C164.388 243.726 171.394 234.989 171.394 234.989L174.017 237.026",
    fill: "#ABABAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.93 232.653C176.93 232.653 171.394 227.405 169.933 227.991C168.472 228.577 160.312 240.822 162.35 242.274C164.388 243.726 171.394 234.989 171.394 234.989L174.017 237.026",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.513 239.318C184.513 239.318 179.265 230.86 177.516 230.86C175.767 230.86 165.848 239.904 165.848 239.904C165.848 239.904 168.77 242.231 169.644 241.653C170.519 241.076 175.469 237.857 175.469 237.857C175.469 237.857 176.344 242.528 179.554 243.403",
    fill: "#ABABAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.513 239.318C184.513 239.318 179.265 230.86 177.516 230.86C175.767 230.86 165.848 239.904 165.848 239.904C165.848 239.904 168.77 242.231 169.644 241.653C170.519 241.076 175.469 237.857 175.469 237.857C175.469 237.857 176.344 242.528 179.554 243.403",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.003 156.56C209.003 156.56 215.703 156.56 216.289 159.481C216.875 162.403 217.452 168.805 217.452 168.805C217.452 168.805 243.114 228.866 242.239 231.49C241.364 234.114 202.295 246.945 201.131 246.945C199.968 246.945 190.636 232.076 190.636 232.076L209.58 220.12L199.671 193.548",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.003 156.56C209.003 156.56 215.703 156.56 216.289 159.481C216.875 162.403 217.452 168.805 217.452 168.805C217.452 168.805 243.114 228.866 242.239 231.49C241.364 234.114 202.295 246.945 201.131 246.945C199.968 246.945 190.636 232.076 190.636 232.076L209.58 220.12L199.671 193.548",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.207 175.181C205.207 175.181 196.758 182.466 196.172 191.799",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.21 174.927C198.21 174.927 193.548 182.178 193.548 190.924",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.58 220.076C209.58 220.076 215.125 215.117 217.452 215.117C219.778 215.117 225.035 216.289 226.198 221.239",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.376 214.54C213.376 214.54 221.248 209.869 223.872 211.916C225.627 213.433 227.02 215.325 227.948 217.452",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.242 165.849L112.496 221.825C112.496 221.825 102.875 228.822 106.373 239.318C107.755 243.464 111.621 245.44 129.411 243.691C130.311 233.118 130.311 222.488 129.411 211.916C127.951 193.295 121.242 165.849 121.242 165.849Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.204 229.347C119.204 229.347 125.195 229.487 125.615 230.178C126.035 230.869 126.035 240.21 124.644 241.19C123.254 242.169 122.274 242.58 121.714 241.19C121.155 239.799 120.184 236.869 120.184 236.869C120.184 236.869 116.423 241.05 112.793 240.21C109.163 239.37 108.752 237.709 107.641 237.289C106.531 236.869 105.018 237.429 102.481 236.414C99.9446 235.4 97.1895 231.682 97.1895 231.682C97.1895 231.682 90.4986 237.534 89.1079 236.834C87.7172 236.134 89.2478 233.913 91.4782 231.542C93.7085 229.172 95.2391 226.802 97.4694 226.242C99.6997 225.682 108.612 224.572 111.402 225.411C114.192 226.251 116.563 227.502 116.834 227.913C117.563 228.486 118.359 228.967 119.204 229.347Z",
    fill: "#ABABAB",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.968 224.467C100.968 224.467 97.2071 223.767 96.7872 226.277C96.3674 228.787 97.347 238.522 98.3178 239.397C98.6281 239.601 98.9811 239.731 99.3496 239.776C99.7181 239.822 100.092 239.783 100.443 239.661C100.794 239.539 101.112 239.339 101.373 239.074C101.634 238.81 101.83 238.489 101.948 238.137C102.499 236.467 102.359 227.694 102.359 227.694C102.359 227.694 102.778 225.306 100.968 224.467Z",
    fill: "#ABABAB",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.939 225.997C107.939 225.997 102.359 222.499 100.942 224.467C99.5249 226.435 101.082 238.26 101.816 239.799C102.551 241.338 105.158 241.89 105.717 240.21C106.277 238.531 106.408 231.578 106.592 231.158",
    fill: "#ABABAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.939 225.997C107.939 225.997 102.359 222.499 100.942 224.467C99.5249 226.435 101.082 238.26 101.816 239.799C102.551 241.338 105.158 241.89 105.717 240.21C106.277 238.531 106.408 231.578 106.592 231.158",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.14 227.948C111 228.367 111.14 240.63 109.469 241.469C107.799 242.309 105.429 242.3 105.429 236.729C105.429 231.158 105.708 224.327 107.239 223.767C108.77 223.207 113.09 225.586 114.63 226.977",
    fill: "#ABABAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.14 227.948C111 228.367 111.14 240.63 109.469 241.469C107.799 242.309 105.429 242.3 105.429 236.729C105.429 231.158 105.708 224.327 107.239 223.767C108.77 223.207 113.09 225.586 114.63 226.977",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.201 236.869L118.942 231.297",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.507 147.971V163.863L152.571 158.099L144.507 147.971Z",
    fill: "#BABABA",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.181 165.472L144.507 147.971L153.953 141.28L154.181 165.472Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.181 137.37C151.181 137.37 153.026 153.262 153.49 157.872C153.953 162.481 154.181 165.481 154.181 165.481C154.181 165.481 168.464 148.863 171.227 145.198C173.991 141.534 174.682 140.362 174.682 140.362L175.382 123.315L151.181 137.37Z",
    fill: "#ABABAB",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.566 140.703C152.952 141.757 154.574 142.456 156.292 142.74C158.01 143.023 159.772 142.883 161.423 142.33C167.545 140.082 169.294 136.207 170.633 134.869C171.507 133.994 173.344 132.787 175.05 131.37L175.382 123.315L151.181 137.37C151.181 137.37 151.338 138.7 151.566 140.703Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.636 150.735L154.181 165.472L165.472 158.099L160.636 150.735Z",
    fill: "#BABABA",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.636 150.735L165.927 165.017L181.601 144.743L176.991 135.297L160.636 150.735Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.315 76.8631C139.772 80.2107 136.525 85.0242 135.122 90.4899C132.997 99.4024 137.493 109.085 137.825 112.067C138.157 115.05 136.88 118.924 138.289 122.607C139.697 126.289 145.924 132.123 146.921 134.851C147.918 137.58 153.499 142.496 159.569 140.274C165.638 138.053 167.545 134.152 168.927 132.805C170.309 131.458 174.175 129.201 176.047 126.682C177.918 124.163 179.099 122.362 179.099 122.362C179.099 122.362 184.015 110.283 184.434 99.5161C184.854 88.7494 178.469 76.5395 166.408 73.1809C154.347 69.8223 144.315 76.8631 144.315 76.8631Z",
    fill: "#ABABAB",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M134.519 105.831C134.519 105.831 134.685 112.933 137.265 114.796C139.846 116.659 145.408 116.546 147.656 115.61C149.904 114.674 151.207 109.933 152.152 108.569C153.096 107.204 156.166 107.93 156.166 107.93C156.166 107.93 158.362 114.14 160.102 114.849C161.843 115.557 167.344 116.773 171.193 114.761C175.041 112.75 175.793 104.957 175.793 104.957C175.793 104.957 178.032 104.528 177.411 103.373C176.79 102.219 159.717 102.236 157.697 102.901C155.676 103.566 155.414 104.476 154.312 104.458C153.21 104.441 151.688 103.286 150.586 103.269C149.484 103.251 134.169 103.522 134.169 103.522L134.519 105.831Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.434 73.242C154.373 69.8834 144.341 76.863 144.341 76.863C140.617 79.628 137.739 83.3782 136.032 87.691C136.513 86.554 138.49 82.3557 142.155 81.4199C146.414 80.3266 146.475 84.2187 151.854 82.9067C157.233 81.5948 165.595 77.3528 169.286 79.4607C172.977 81.5685 175.898 85.9592 174.394 90.5248C172.889 95.0904 172.741 98.519 174.254 99.6822C175.767 100.846 177.604 104.536 177.752 106.828C177.866 108.717 180.376 110.003 183.044 109.662C183.817 106.349 184.294 102.974 184.469 99.5773C184.863 88.8193 178.469 76.6006 166.434 73.242Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.714 117.009C148.714 117.009 147.297 119.055 148.592 119.991C148.901 120.315 149.316 120.518 149.761 120.564C150.206 120.611 150.654 120.498 151.023 120.245",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.184 119.09C151.172 119.956 152.385 120.526 153.682 120.735C155.668 120.988 157.741 118.985 157.741 118.985",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.023 119.825C157.023 119.825 157.653 120.752 159.472 119.633C159.472 119.633 161.939 118.968 160.496 116.204",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.845 124.802C148.845 124.802 155.615 127.426 161.536 123.586",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.21 109.085C165.166 110.283 164.58 111.254 163.907 111.245C163.233 111.236 162.726 110.248 162.779 109.05C162.831 107.851 163.408 106.88 164.082 106.889C164.755 106.898 165.262 107.878 165.21 109.085Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.91 109.207C147.91 110.414 147.28 111.376 146.606 111.368C145.933 111.359 145.426 110.379 145.478 109.181C145.531 107.983 146.108 107.012 146.781 107.021C147.455 107.029 147.962 108.009 147.91 109.207Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.519 105.831C134.519 105.831 134.685 112.933 137.265 114.796C139.846 116.659 145.408 116.546 147.656 115.61C149.904 114.674 151.207 109.933 152.152 108.569C153.096 107.204 156.166 107.93 156.166 107.93C156.166 107.93 158.362 114.14 160.102 114.849C161.843 115.557 167.344 116.773 171.193 114.761C175.041 112.75 175.793 104.957 175.793 104.957C175.793 104.957 178.032 104.528 177.411 103.373C176.79 102.219 159.717 102.236 157.697 102.901C155.676 103.566 155.414 104.476 154.312 104.458C153.21 104.441 151.688 103.286 150.586 103.269C149.484 103.251 134.169 103.522 134.169 103.522L134.519 105.831Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.411 103.391L184.592 106.915L184.102 108.052L175.793 104.974L177.411 103.391Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.688 102.918C155.668 103.574 155.405 104.493 154.303 104.475C153.201 104.458 151.679 103.303 150.577 103.286C149.475 103.268 134.16 103.539 134.16 103.539L134.37 104.904L150.42 104.659C150.42 104.659 152.764 104.466 152.458 106.286C152.02 108.822 152.143 108.577 152.143 108.577C153.079 107.213 156.157 107.939 156.157 107.939L156.376 108.525C156.227 107.37 156.105 105.568 156.717 104.965C157.644 104.09 161.843 104.344 165.621 104.16C169.025 104.17 172.423 104.442 175.784 104.974L177.324 103.312C175.959 102.236 159.665 102.271 157.688 102.918Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.805 111.184C177.805 111.184 183.192 103.916 185.79 105.551C188.388 107.187 186.315 114.726 184.627 118.146C182.939 121.566 178.915 122.423 178.137 119.668",
    fill: "#ABABAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.805 111.184C177.805 111.184 183.192 103.916 185.79 105.551C188.388 107.187 186.315 114.726 184.627 118.146C182.939 121.566 178.915 122.423 178.137 119.668",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.446 243.402H76.8105L68.3091 196.46H135.945L144.446 243.402Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.822 243.402H74.1866L65.6852 196.46H133.321L141.822 243.402Z",
    fill: "#004087",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8105 243.402H141.822L135.56 208.828L76.8105 243.402Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.525 243.402H74.1866V246.245H180.525V243.402Z",
    fill: "#004087",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.525 243.402H142.732V246.245H180.525V243.402Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3256_12762"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 317.493,
    height: 300,
    fill: "white",
    transform: "translate(0.253662)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutorizationRequest);
export default __webpack_public_path__ + "static/media/autorization-request.1a8ec8fff2a0b20d6d1066ef42d8e72d.svg";
export { ForwardRef as ReactComponent };